<div class="palantir-entity-change-logs">
  @for (log of logs(); track $index; let index = $index) {
    @if (!logs()[index - 1] || logs()[index - 1].date !== log.date) {
      <palantir-text type="subtitle">{{ log.date }}</palantir-text>
    }

    <div
      class="palantir-entity-change-logs__log"
      [style]="{
        '--palantir-entity-change-log-color': log.color
          ? (log.color | labels).color
          : ('blue-grey' | labels).color,
        '--palantir-entity-change-log-background-color': log.color
          ? (log.color | labels).color + '1a'
          : ('blue-grey' | labels).color + '1a',
      }"
    >
      <div class="palantir-entity-change-logs__header">
        <palantir-avatar-group>
          @for (avatar of log.avatars; track $index) {
            @if (avatar.src) {
              <palantir-avatar size="3xs">
                <img [src]="avatar.src" alt="User avatar" />
              </palantir-avatar>
            }

            @if (avatar.icon) {
              <palantir-avatar size="3xs">
                <palantir-icon [name]="avatar.icon" />
              </palantir-avatar>
            }
          }
        </palantir-avatar-group>

        <palantir-text
          class="palantir-entity-change-logs__title"
          type="subtitle"
          [innerHTML]="log.title"
        />

        <div class="palantir-flex-auto"></div>

        <palantir-text type="subtitle">{{ log.datetime }}</palantir-text>
      </div>

      @if (log.items?.length) {
        <div class="palantir-entity-change-logs__content">
          @for (item of log.items; track $index) {
            <palantir-entity-change-log-item [item]="item" />
          }
        </div>
      }
    </div>
  }
</div>
